import { render, staticRenderFns } from "./FirmPoliciesTable.vue?vue&type=template&id=3ff04462"
import script from "./FirmPoliciesTable.vue?vue&type=script&lang=js"
export * from "./FirmPoliciesTable.vue?vue&type=script&lang=js"
import style0 from "./FirmPoliciesTable.vue?vue&type=style&index=0&id=3ff04462&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports